import React from "react";
import { IonIcon, IonLabel } from "@ionic/react";
import { basketOutline, removeOutline, addOutline } from "ionicons/icons";
import { Product } from "@core/types";
import { useCartData } from "../../../../../providers/cartDataStore";
import { useProductCardActions } from "../../../../../providers/useProductActions";

import styles from "./MainPageProduct.module.scss";
import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";

interface CartButtonProps {
  product: Product;
}

const cx = classNames.bind(styles);

export const CartButton = ({ product }: CartButtonProps) => {
  const { cartProductsMap } = useCartData();
  const { addToCart, removeProductFromCart, showProductDetail } = useProductCardActions();
  const { t } = useTranslation();
  const cartQuantity = cartProductsMap[product.id]?.quantity ?? 0;
  return (
    <>
      {!cartQuantity ? (
        <div className="block w-full">
          {product.stockQuantity > 0 ? (
            <div
              className={cx("ion-text-center ion-no-padding", { disabled: !product?.purchasable })}
              onClick={(e) => {
                addToCart(product);
                e.stopPropagation();
              }}
            >
              {product.stockStatus === "instock" && <div className={cx(styles.basketButton)}>{t("Add to cart")}</div>}
            </div>
          ) : (
            <div
              className={cx("ion-text-center ion-no-padding")}
              onClick={(e) => {
                showProductDetail(product.id);
                e.stopPropagation();
              }}
            >
              {product.stockStatus === "instock" && <IonIcon icon={basketOutline} className={cx(styles.icon)} />}
            </div>
          )}
        </div>
      ) : (
        <div className={cx("product-card-counter")} onClick={(e) => e.stopPropagation()}>
          <div className={cx("product-card-background")}>
            <div onClick={() => removeProductFromCart(product.id)} className={cx(styles.iconBackground)}>
              {product.stockStatus === "instock" && <IonIcon className={cx("counter-button")} icon={removeOutline} />}
            </div>
            <div className={cx(styles.quantityCounterIrskom)}>
              <IonLabel>{cartQuantity}</IonLabel>
            </div>
            <div onClick={() => addToCart(product)} className={cx(styles.iconBackground)}>
              {product.stockStatus === "instock" && product.stockQuantity > cartQuantity && (
                <IonIcon className={cx("counter-button")} icon={addOutline} />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
